<template>
  <div class="position-relative" :style="{ '--rdrive-ts-overlay': theme.loadingOverlay }">
    <v-card class="mb-4">
      <v-card-title class="d-flex justify-space-between align-center">
        <div class="d-flex align-center">
          <span>{{ title }}</span>
          <v-tooltip v-if="infoText" location="bottom">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                icon="mdi-information"
                size="small"
                class="ms-1"
              ></v-icon>
            </template>
            <span>{{ infoText }}</span>
          </v-tooltip>
        </div>
        <div class="d-flex align-center">
          <v-btn-toggle v-model="selectedGroupBy" variant="outlined" mandatory class="me-2">
            <v-btn
              v-for="option in groupByOptions"
              :key="option"
              :value="option"
            >{{ t(option) }}</v-btn>
          </v-btn-toggle>
          <v-btn
            icon
            elevation="0"
            text
            @click="resetZoom"
            class="me-2"
            :disabled="!isZoomed || isLoading"
          >
            <v-icon>mdi-refresh</v-icon>
            <v-tooltip activator="parent" location="bottom">
              <span>{{ t('resetZoom') }}</span>
            </v-tooltip>
          </v-btn>
          <v-btn
            v-if="showToolbar"
            class="rdrive-chart-export"
            icon
            elevation="0"
            text
            @click="downloadChart"
            :disabled="isLoading"
          >
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-card-text style="min-height: 400px" class="position-relative">
        <v-chart class="chart" ref="chartRef" :option="chartOption" autoresize @zr:click="handleChartClick" />

        <!-- Loading overlay (cumulative mode only) -->
        <div v-if="showLoadingOverlay" class="chart-loading-overlay">
          <v-progress-circular
            indeterminate
            color="primary"
            size="60"
          ></v-progress-circular>
          <div class="mt-3 text-center">{{ t('loading') }}</div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script src="./model.js"></script>
<style src="./style.css" scoped></style>
